import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LodashService } from '../services/lodash.service';
import * as _ from 'lodash';
import * as moment from 'moment';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Pipe({ name: 'capitalizeWords' })
export class CapitalizeWords implements PipeTransform {
  constructor(private efoLd: LodashService) {}

  transform(v) {
    return this.efoLd.capitalizeWords(v.replace(/\_/g, ' '));
  }
}

@Pipe({ name: 'dashWords' })
export class DashWords implements PipeTransform {
  transform(v) {
    return v.replace(/\s/g, '-');
  }
}

@Pipe({ name: 'underscoreWords' })
export class UnderscoreWords implements PipeTransform {
  transform(v) {
    return v.replace(/\s/g, '_');
  }
}

@Pipe({ name: 'phonenumber' })
export class PhoneNumber implements PipeTransform {
  constructor(private efoLd: LodashService) {}

  transform(v) {
    return _.isUndefined(v) || !v
      ? ''
      : v.substr(0, 3) + '-' + v.substr(3, 3) + '-' + v.substr(6, 4);
  }
}

@Pipe({ name: 'month' })
export class Month implements PipeTransform {
  constructor() {}

  transform(v) {
    return _.isUndefined(v) || !v ? '' : moment(v).format('YYYY-MM');
  }
}

@Pipe({ name: 'moment' })
export class Moment implements PipeTransform {
  constructor(private efoLd: LodashService) {}

  transform(v) {
    return function (v, params) {
      // first arg is the input, rest are filter params
      return _.isUndefined(v) || !v
        ? ''
        : this.efoLd.isNumeric(v)
        ? moment.unix(v).format(params)
        : moment(v).format(params);
    };
  }
}

@Pipe({ name: 'keepHtml', pure: false })
export class EscapeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(content) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}

@Pipe({ name: 'has' })
export class Has implements PipeTransform {
  constructor() {}

  transform(o, k) {
    //console.log(o,k,_.has(o, k));
    return _.has(o, k);
  }
}

@Pipe({ name: 'isMobile' })
export class IsMobile implements PipeTransform {
  constructor() {}

  transform(o) {
    console.log('Checking isMobile', jQuery('html').attr('class'));
    return jQuery('html').hasClass('mobile');
  }
}

@Pipe({ name: 'isDesktop' })
export class IsDesktop implements PipeTransform {
  constructor() {}

  transform(o) {
    console.log('Checking isDesktop', jQuery('html').attr('class'));
    return jQuery('html').hasClass('desktop');
  }
}
